import api from "./api";
import type { AxiosRequestConfig, AxiosResponse } from "axios";

type OptionalSessionConfig = AxiosRequestConfig & {
  skipAuthRedirect?: boolean;
};

export interface AuthUserResponse {
  id: string;
  email: string;
  username: string | null;
  firstName: string | null;
  lastName: string | null;
  role: string | null;
  dateOfBirth?: string | null;
  imageMediaId?: string | null;
  imageUrl?: string | null;
  roleType?: string | null;
  roleId?: string | null;
}

export interface AuthLoginResponse {
  user: AuthUserResponse;
  tokens: { accessToken: string; refreshToken: string };
  permissions?: string[];
}

export interface AuthMeResponse {
  user: AuthUserResponse;
  permissions?: string[];
}

const authService = {
  login(data: {
    email: string;
    password: string;
  }): Promise<AxiosResponse<{ data: AuthLoginResponse }>> {
    return api.post("/auth/login", data);
  },

  getMe(
    config: OptionalSessionConfig = {},
  ): Promise<AxiosResponse<{ data: AuthMeResponse }>> {
    return api.get("/auth/me", config);
  },

  logout(accessToken?: string | null): Promise<AxiosResponse> {
    return api.post("/auth/logout", undefined, {
      headers: accessToken
        ? { Authorization: `Bearer ${accessToken}` }
        : undefined,
      skipAuthRedirect: true,
    } as OptionalSessionConfig);
  },

  verifyEmailOtp(data: { email: string; code: string }) {
    return api.post("/auth/verify-email-otp", data, {
      skipAuthRedirect: true,
    } as OptionalSessionConfig);
  },

  resendEmailOtp(data: { email: string }) {
    return api.post("/auth/resend-email-otp", data, {
      skipAuthRedirect: true,
    } as OptionalSessionConfig);
  },

  forgotPassword(data: { email: string }) {
    return api.post("/auth/forgot-password", data, {
      skipAuthRedirect: true,
    } as OptionalSessionConfig);
  },

  resetPassword(data: { email: string; code: string; newPassword: string }) {
    return api.post("/auth/reset-password", data, {
      skipAuthRedirect: true,
    } as OptionalSessionConfig);
  },

  changePassword(data: { currentPassword: string; newPassword: string }) {
    return api.post("/auth/change-password", {
      currentPassword: data.currentPassword,
      newPassword: data.newPassword,
    });
  },
};

export default authService;
